import React from "react";

const BrickListItem = ({ width = 28, height = 30, number = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 0H4V6H0V30H28V6H24V0Z"
      fill="#F5CB38"
    />
    {number && (
      <text
        fill="black"
        xmlSpace="preserve"
        style={{ "white-space": "pre" }}
        fontFamily="IBM Plex Sans"
        fontSize="16"
        letterSpacing="-0.333333px"
      >
        <tspan x="9" y="22.5">
          {number}
        </tspan>
      </text>
    )}
  </svg>
);

export default BrickListItem;
